import React from "react";
import "./RecommendedButtonFieldUpdateCard.scss";
import aiChatlogo from "../../../../../../assets/Images/aiChatlogo.png";
import { CHAT } from "../../../../../../util/constants";

export const RecommendedButtonFieldUpdateCard = ({
  message,
  onInputChange,
  onSend,
}) => {
  const d = new Date(message.timestamp || Date.now());
  const promptDate = d.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
  const promptTime = d.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
  });
  const promptTimestamp = `${promptDate} | ${promptTime}`;

  return (
    <div className="order-chat-bubble ai recommended-button-field-update-card">
      <div className="order-ai-card recommended-button-field-update-card__card">
        <div className="order-ai-card-header recommended-button-field-update-card__header">
          <div className="order-ai-card-title-logo">
            <img
              src={aiChatlogo}
              alt={CHAT.AXON_AI}
              aria-hidden="true"
              className="order-ai-logo"
              style={{ width: 32, height: 32 }}
            />
          </div>
          <div className="order-ai-card-title-Avatar recommended-button-field-update-card__title">
            <span>{CHAT.AXON_AI}</span>
            <div className="order-ai-card-time">{promptTimestamp}</div>
          </div>
        </div>
        <div className="order-ai-card-body recommended-button-field-update-card__body">
          {/*
          <div className="recommended-button-field-update-card__row">
            <div className="recommended-button-field-update-card__label">
              Input Field Value to update:
            </div>
            <span className="recommended-button-field-update-card__target">
              Update {message.to || "fields update"} To
            </span>
          </div>
          */}
          <div className="recommended-button-field-update-card__prompt">
            <div className="recommended-button-field-update-card__label">
              Input field value to update
            </div>
            <div className="recommended-button-field-update-card__row">
              <span className="recommended-button-field-update-card__verb">
                Update
              </span>
              <span className="recommended-button-field-update-card__target">
                {message.to || "fields update"}
              </span>
              <span className="recommended-button-field-update-card__verb">
                to
              </span>
            </div>
          </div>
          <input
            type="text"
            className="recommended-button-field-update-card__input"
            placeholder="Enter value"
            value={message.draftValue || ""}
            onChange={(event) => onInputChange(message.id, event.target.value)}
            onKeyDown={(event) => {
              if (event.key === "Enter") {
                event.preventDefault();
                onSend(message);
              }
            }}
          />
          {/*
          <button
            className="recommended-button-field-update-card__send"
            onClick={() => onSend(message)}
            disabled={!String(message.draftValue || "").trim()}
          >
            Send
          </button>
          */}
          <div className="recommended-button-field-update-card__footer">
            <div className="recommended-button-field-update-card__hint">
              Press Enter or use Send to continue.
            </div>
            <button
              className="recommended-button-field-update-card__send"
              onClick={() => onSend(message)}
              disabled={!String(message.draftValue || "").trim()}
            >
              Send
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
